/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandPoliciesRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandPoliciesResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandPolicies = (request: SetBrandPoliciesRequest, options?: CashRequestOptions) => post<SetBrandPoliciesRequest, SetBrandPoliciesResponse>("/2.0/cash/set-brand-policies", request, {...options, rejectOnError: true })